import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=8602e682"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports